import classNames from 'classnames';
import type { FC, MouseEvent, ReactNode, Ref } from 'react';
import './FormInputButton.css';

type FormInputButtonProps = {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  accent?: 'normal' | 'negative';
  onClick: (e: MouseEvent) => void;
  buttonRef?: Ref<HTMLButtonElement>;
  dataTestId?: string;
};

export const FormInputButton: FC<FormInputButtonProps> = ({
  className,
  accent,
  buttonRef,
  dataTestId,
  ...otherProps
}) => (
  <button
    {...otherProps}
    className={classNames(
      'form-input-button',
      accent === 'negative' && 'form-input-button--negative',
      className,
    )}
    type='button'
    // prevent focusing input button instead of jumping to next input on tab
    tabIndex={-1}
    ref={buttonRef}
    data-testid={dataTestId}
  />
);
